import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { connect } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';

import { Input, Popconfirm, Tooltip,Button } from 'antd';
import translation from '../../../../../commons/translation';
import {
  getEmergencyWorkOrdersList,
  deleteWorkOrder,
} from '../../../Utils/FormCalls';
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';


const EmergencyWorkOrders = (props) => {
  // const [userList, setUserList] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['WorkOrder', 'Description'],
    firstTitle: 'WorkOrder',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/EWODetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };
  dayjs.extend(utc);
  dayjs.extend(timezone);

  useEffect(() => {
    const fetchData = async () => {
      const dataSource = await getEmergencyWorkOrdersList();
      setDataSource(dataSource);
    };
    fetchData();
  }, []);

  const editWorkOrder = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <SearchOutlined
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          
          style={{ width: 90, marginRight: 8, }}
        >
          {translation(props.translationCache, `Search`)}
        </SearchOutlined>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const deleteById = async (id) => {
    await deleteWorkOrder(id);
    const dataSource = await getEmergencyWorkOrdersList();
    setDataSource(dataSource);
  };

  // const changeStatus = async (id) => {
  //   await changeWorkOrderStatus(id);
  //   const dataSource = await getEmergencyWorkOrdersList();
  //   setDataSource(dataSource);
  // };

  const columns = [
    {
      title: translation(props.translationCache, constant.workOrder),
      dataIndex: 'WorkOrder',
      key: 'WorkOrder',
      ...getColumnSearchProps('WorkOrder')
    },
    {
      title: translation(props.translationCache, constant.workOrderDescription),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(props.translationCache, constant.recordedDate),
      dataIndex: 'RecordDate',
      key: 'RecordDate',
      filter: true,
      render: (text) => text ? dayjs(text).local().format('YYYY-MM-DD HH:mm:ss') : null
    },
    {
      title: translation(props.translationCache, constant.actualStart),
      dataIndex: 'ActualStart',
      key: 'ActualStart',
      filter: true,
      render: (text) => text ? dayjs(text).local().format('YYYY-MM-DD HH:mm:ss') : null
    },
    {
      title: translation(props.translationCache, constant.actualEnd),
      dataIndex: 'ActualEnd',
      key: 'ActualEnd',
      filter: true,
      render: (text) => text ? dayjs(text).local().format('YYYY-MM-DD HH:mm:ss') : null
    },
    {
      title: translation(props.translationCache, constant.site),
      dataIndex: 'SiteName',
      key: 'SiteName'
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            disabled={record.Status === 'Inactive'}
            style={{ marginRight: '5px' }}
            onClick={() => editWorkOrder(record)}
          >
            <Tooltip title={'Edit'}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(props.translationCache, constant.areYouSureThatYouWantToDeleteTheEmergencyWorkOrder)}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteById(record.Id)}
            okText={translation(props.translationCache, constant.yes)}
            cancelText={translation(props.translationCache, constant.no)}
          >
            <Button>
              <Tooltip title={translation(props.translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        // userList={userList}
        config={config}
        delete={deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(EmergencyWorkOrders);